module.exports = __webpack_public_path__ + "static/media/compare_2.f99df99c.svg";